import * as React from 'react';
import { IgcPivotDataSelectorComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import type { IgcPivotDataSelectorComponentEventMap } from 'igniteui-webcomponents-grids/grids/index.js';
import { type EventName, createComponent } from '../react-props.js';

/**
 * Pivot Data Selector provides means to configure the pivot state of the Pivot Grid via a vertical panel UI
 * @fires columnsExpandedChange - Emitted when the columns panel is expanded or collapsed.
 * @fires rowsExpandedChange - Emitted when the rows panel is expanded or collapsed.
 * @fires filtersExpandedChange - Emitted when the filters panel is expanded or collapsed.
 * @fires valuesExpandedChange - Emitted when the values panel is expanded or collapsed.
 */
export const IgrPivotDataSelector = createComponent({
  tagName: 'igc-pivot-data-selector',
  displayName: 'IgrPivotDataSelector',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
  events: {
    onColumnsExpandedChange: 'columnsExpandedChange' as EventName<
      IgcPivotDataSelectorComponentEventMap['columnsExpandedChange']
    >,
    onRowsExpandedChange: 'rowsExpandedChange' as EventName<
      IgcPivotDataSelectorComponentEventMap['rowsExpandedChange']
    >,
    onFiltersExpandedChange: 'filtersExpandedChange' as EventName<
      IgcPivotDataSelectorComponentEventMap['filtersExpandedChange']
    >,
    onValuesExpandedChange: 'valuesExpandedChange' as EventName<
      IgcPivotDataSelectorComponentEventMap['valuesExpandedChange']
    >,
  },
});

export type IgrPivotDataSelector = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrPivotDataSelectorModule = Component;
